import Vue from 'vue'

export default el => new Vue({el})
